import { useId } from 'react'
import { Box } from '@mui/material'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { PlanUsageCardShellFrame } from './PlanUsageCardShellFrame'

/**
 * @param {{ sectionAriaLabel: string, title: string, titleIcon?: import('react').ReactNode, intro?: readonly [string, string], children: import('react').ReactNode }} props
 */
export default function PlanUsageCardShell({ sectionAriaLabel, title, titleIcon, intro, children }) {
  const headingId = useId()
  return (
    <Box component="section" aria-label={intro ? undefined : sectionAriaLabel} aria-labelledby={intro ? headingId : undefined} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', width: '100%', gap: 1, boxSizing: 'border-box' }}>
      {intro ? <SettingsSectionIntro headingId={headingId} lines={intro} /> : null}
      <PlanUsageCardShellFrame title={title} titleIcon={titleIcon} intro={intro}>{children}</PlanUsageCardShellFrame>
    </Box>
  )
}
